<script setup>
const props = defineProps({
    initialValue: {
        type: String,
        default: ''
    }
})

const modelValue = ref(props.initialValue)

const emits = defineEmits(['updateFilter'])

const updateFilter = (newValue) => {
    modelValue.value = newValue
    emits('updateFilter', newValue)
}
</script>
<template>
    <div class="single-filter-ui">
        <v-text-field
            v-model="modelValue"
            density="compact"
            hide-details
            class="mb-2"
            clearable
            @update:modelValue="updateFilter($event)"
        ></v-text-field>
    </div>
</template>
